


import React, { useState, useEffect } from "react";
import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
import Modal from "react-modal";
import DEFAULT_IMAGE from "./food.jpg";
import { Link } from "react-router-dom";
import Cateringascrolling from "./Cateringascrolling";
import axios from "axios";
import { useLoader } from "../../../context/LoaderProvider.jsx";

Modal.setAppElement("#root");

export default function Cateringsmenuaddingpage() {
    const isMobile = window.innerWidth <= 768;
    const DEFAULT_IMAGE = "/default-image.jpg";
    const { showLoader, hideLoader } = useLoader();
    // ---- DEFAULT DATA ----
    const defaultPackages = {
        birthday: [
            {
                id: 1,
                name: "Starter Delight",
                type: "veg",
                image: "",
                items: [
                    { id: 1, name: "Paneer Tikka", price: 120 },
                    { id: 2, name: "Spring Roll", price: 80 },
                    { id: 3, name: "Veg Momos", price: 100 },
                    { id: 4, name: "Cheese Balls", price: 90 },
                    { id: 5, name: "Aloo Tikki", price: 70 },
                    { id: 6, name: "Mini Samosa", price: 60 },

                ],
            },
            {
                id: 2,
                name: "Non-Veg Fiesta",
                type: "nonveg",
                image: "",
                items: [
                    { id: 1, name: "Chicken Tikka", price: 180 },
                    { id: 2, name: "Chicken Momos", price: 120 },
                    { id: 3, name: "Mutton Seekh", price: 220 },
                    { id: 4, name: "Fish Fry", price: 200 },
                    { id: 5, name: "Chicken Wings", price: 160 },
                    { id: 6, name: "Egg Roll", price: 90 },
                    // { id: 7, name: "Chicken Popcorn", price: 140 },
                    // { id: 8, name: "Kebab Platter", price: 250 },
                    // { id: 9, name: "Prawn Fry", price: 300 },
                    // { id: 10, name: "Chicken Soup", price: 100 },
                ],
            },
            {
                id: 3,
                name: "Drinks & Beverages",
                type: "drinks",
                image: "",
                items: [
                    { id: 1, name: "Cold Drink", price: 40 },
                    { id: 2, name: "Lassi", price: 60 },
                    { id: 3, name: "Juice", price: 70 },
                    { id: 4, name: "Mocktail", price: 120 },
                    { id: 5, name: "Cold Coffee", price: 90 },
                    { id: 6, name: "Milkshake", price: 110 },

                ],
            },
        ],
    };
    const [editingItem, setEditingItem] = useState(null); // { packageId, item }
    const [isItemModalOpen, setIsItemModalOpen] = useState(false);
    // Modal state
    const [isPackageModalOpen, setIsPackageModalOpen] = useState(false);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingPackage, setEditingPackage] = useState({
        id: 0,
        name: "",
        type: "Veg",
        items: [{ name: "", price: 0 }],
        image: "",
    });

    const [loading, setLoading] = useState(true);


    const mapPackageType = (type) => {
        const safeType = type?.toLowerCase() || "";
        switch (safeType) {
            case "veg":
                return "Veg";
            case "nonveg":
                return "Non_veg";
            case "drinks":
                return "Drinks";
            default:
                return "Veg"; // fallback
        }
    };


    const closePackageModal = () => {
        setIsPackageModalOpen(false);
    };
    const [packagesData, setPackagesData] = useState([]);
    const [formData, setFormData] = useState({
        packageName: "",
        packageType: "Veg",
        imageFile: null,
        items: [],
        totalPrice: 0,
    });
    const [selectedPackage, setSelectedPackage] = useState(null);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);


    // 🟢 OPEN Edit Modal and Load Package Data
    const handleEditPackage = async (packageId) => {
        try {
            const token = localStorage.getItem("authToken");

            const response = await axios.get(
                `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/package/getbyid/${packageId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            const pkg = response.data;
            setSelectedPackage(pkg);

            setFormData({
                packageName: pkg.packageName,
                packageType: pkg.packageType,
                items: pkg.items || [],
                totalPrice: pkg.totalPrice || 0,
                imageFile: null, // reset new image
                existingImage: pkg.image, // store existing image path
            });

            setIsEditModalOpen(true);
        } catch (error) {
            console.error("Error fetching package:", error);
            alert("Failed to fetch package data.");
        }
    };

    // 🟣 UPDATE Package
    const handleUpdatePackage = async () => {
        try {
            const vendorId = Number(localStorage.getItem("vendorId"));
            const token = localStorage.getItem("authToken");

            if (!selectedPackage) return alert("No package selected.");

            // Prepare updated package object
            const updatedPackage = {
                id: selectedPackage.id,
                vendorId,
                packageName: formData.packageName || selectedPackage.packageName,
                packageType: formData.packageType || selectedPackage.packageType, // ✅ ensure this is taken correctly
                items: formData.items?.length ? formData.items : selectedPackage.items,
                totalPrice: (formData.items?.length ? formData.items : selectedPackage.items)
                    .reduce((sum, item) => sum + Number(item.price || 0), 0),
            };

            const formDataToSend = new FormData();
            formDataToSend.append(
                "packageData",
                new Blob([JSON.stringify(updatedPackage)], { type: "application/json" })
            );

            // ✅ Append image only if a new file is selected
            if (formData.imageFile instanceof File) {
                formDataToSend.append("image", formData.imageFile);
            }
            showLoader();
            const response = await axios.put(
                `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/vendor/${vendorId}/${selectedPackage.id}`,
                formDataToSend,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            console.log("✅ Package updated successfully:", response.data);
            alert("Package updated successfully!");
            setIsEditModalOpen(false);
            fetchPackages();
        } catch (error) {
            console.error("❌ Error updating package:", error);
            if (error.response) {
                console.error("Server error data:", error.response.data);
            }
            alert("Failed to update package. Check console for details.");
        } finally {
            hideLoader();
        }
    };







    const handleSavePackagess = async () => {
        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                alert("Token missing in localStorage");
                return;
            }

            const payload = {
                id: editingPackage.id,
                vendorId: editingPackage.vendorId,
                packageName: editingPackage.packageName,
                packageType: editingPackage.packageType,
                image: editingPackage.image || "null",
                totalPrice: editingPackage.totalPrice
            };
            showLoader();
            const response = await fetch(
                `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/vendor/${editingPackage.vendorId}/${editingPackage.id}`,
                {
                    method: "PUT",
                    headers: {
                        accept: "*/*",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify(payload),
                }
            );

            if (!response.ok) throw new Error("Failed to update package");

            // Update local state
            setPackagesData((prevData) =>
                prevData.map((pkg) =>
                    pkg.id === editingPackage.id ? { ...editingPackage } : pkg
                )
            );

            closePackageModal();
            alert("Package updated successfully!");
        } catch (error) {
            console.error("Failed to update package:", error);
            alert(`Failed to update package: ${error.message}`);
        } finally {
            hideLoader();
        }
    };

    const openItemModal = (packageId, item) => {
        setEditingItem({ packageId, ...item }); // store both packageId and item details
        setIsItemModalOpen(true);
    };


    const closeItemModal = () => {
        setEditingItem(null);
        setIsItemModalOpen(false);
    };

    const handleSaveItem = async () => {
        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                alert("⚠️ VendorId or token missing in localStorage");
                return;
            }

            const payload = {
                id: editingItem.id,
                itemName: editingItem.itemName,
                price: Number(editingItem.price),
            };

            const url = `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/vendor/${editingItem.packageId}/items/${editingItem.id}`;

            const response = await fetch(url, {
                method: "PUT", // or PATCH if your backend uses partial update
                headers: {
                    accept: "*/*",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || "Failed to update item");
            }

            // ✅ Update the local UI immediately without refetch
            setPackagesData((prevData) =>
                prevData.map((pkg) =>
                    pkg.id === editingItem.packageId
                        ? {
                            ...pkg,
                            items: pkg.items.map((i) =>
                                i.id === editingItem.id
                                    ? { ...i, itemName: editingItem.itemName, price: Number(editingItem.price) }
                                    : i
                            ),
                        }
                        : pkg
                )
            );

            closeItemModal();
            alert("✅ Item updated successfully!");
        } catch (error) {
            console.error("❌ Failed to update item:", error);
            alert(`❌ Failed to update item: ${error.message}`);
        }
    };





    // Fix image URL from API
    const getValidImageUrl = (url) => {
        if (!url) return "/default-image.jpg"; // fallback

        try {
            // Decode URL
            let decoded = decodeURIComponent(url);

            // Remove duplicate base path if present
            if (decoded.startsWith("http://localhost:9000/caterings/http")) {
                const parts = decoded.split("http://localhost:9000/caterings/");
                decoded = `http://localhost:9000/caterings/${parts[parts.length - 1]}`;
            }

            return decoded;
        } catch (err) {
            console.error("Error parsing image URL:", err);
            return "/default-image.jpg";
        }
    };

    // Optional: fetch image as blob (for CORS issues)
    const fetchImageBlob = async (url) => {
        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error("Failed to fetch image");
            const blob = await response.blob();
            return URL.createObjectURL(blob);
        } catch (err) {
            console.error(err);
            return "/default-image.jpg";
        }
    };

    // --- FETCH PACKAGES ---
    const fetchPackages = async () => {
        try {
            showLoader();
            const vendorId = localStorage.getItem("vendorId");
            const token = localStorage.getItem("authToken");

            if (!vendorId || !token) {
                console.error("🚫 VendorId or Token not found");
                return;
            }

            const response = await fetch(
                `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/package/${vendorId}`,
                {
                    method: "GET",
                    headers: {
                        accept: "*/*",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (!response.ok) throw new Error("Failed to fetch packages");

            const data = await response.json();

            // Fix image URLs
            const fixedData = await Promise.all(
                data.map(async (pkg) => ({
                    ...pkg,
                    imageUrl: await fetchImageBlob(getValidImageUrl(pkg.image)),
                }))
            );

            setPackagesData(fixedData);
        } catch (error) {
            console.error("Error fetching packages:", error);
        } finally {
            setLoading(false);
            hideLoader();
        }
    };

    useEffect(() => {
        fetchPackages();
    }, []);


    // ---- LOCAL STORAGE LOAD ----
    useEffect(() => {
        const saved = localStorage.getItem("packagesData");
        if (saved) {
            setPackagesData(JSON.parse(saved));
        } else {
            setPackagesData(defaultPackages); // load default if nothing in storage
        }
    }, []);

    // ---- LOCAL STORAGE SAVE ----
    useEffect(() => {
        localStorage.setItem("packagesData", JSON.stringify(packagesData));
    }, [packagesData]);

    // ---- MODAL HANDLERS ----
    const openModal = (pkg = null) => {
        if (pkg) {
            setEditingPackage(pkg);
            setFormData({
                name: pkg.name,
                type: pkg.type,
                items: pkg.items.map((i) => ({ name: i.name, price: i.price })),
                image: pkg.image || "",
            });
        } else {
            setEditingPackage({
                id: 0,
                name: "",
                type: "Veg",
                items: [{ name: "", price: 0 }],
                image: "",
            });
            setFormData({ name: "", type: "Veg", items: [{ name: "", price: 0 }], image: "" });
        }
        setIsModalOpen(true);
    };


    const closeModal = () => setIsModalOpen(false);

    // ---- FORM HANDLERS ----
    const handleAddItem = () =>
        setFormData({ ...formData, items: [...formData.items, { name: "", price: "" }] });

    const handleItemChange = (i, field, value) => {
        const updated = [...formData.items];
        updated[i][field] = value;
        setFormData({ ...formData, items: updated });
    };

    const handleRemoveItem = (i) => {
        setFormData({ ...formData, items: formData.items.filter((_, idx) => idx !== i) });
    };

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData((prev) => ({
                ...prev,
                image: file, // ✅ store File object
            }));
        }
    };


    const handleDeleteItemss = async (packageId, itemId) => {
        try {

            const token = localStorage.getItem("authToken");
            if (!token) {
                alert("⚠️ Token missing in localStorage");
                return;
            }

            const response = await fetch(
                `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/vendor/items/${packageId}/${itemId}`,
                {
                    method: "DELETE",
                    headers: {
                        accept: "*/*",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (!response.ok) throw new Error("Failed to delete item");

            // ✅ Remove the deleted item from state
            setPackagesData((prevData) =>
                prevData.map((pkg) =>
                    pkg.id === packageId
                        ? { ...pkg, items: pkg.items.filter((item) => item.id !== itemId) }
                        : pkg
                )
            );

            alert("Item deleted successfully!");
        } catch (error) {
            console.error("❌ Failed to delete item:", error);
            alert(`Failed to delete item: ${error.message}`);
        }
    };

    // ---- ADD/UPDATE PACKAGE ----
    const handleSavePackage = async () => {
        try {
            const vendorId = localStorage.getItem("vendorId");
            const token = localStorage.getItem("authToken");

            const packageData = {
                id: editingPackage?.id || 0,
                vendorId: Number(vendorId),
                packageName: formData.name,
                packageType: mapPackageType(formData.type),
                items: formData.items.map((item) => ({
                    id: item.id || 0,
                    itemName: item.name,
                    price: Number(item.price) || 0,
                })),
                totalPrice: formData.items.reduce(
                    (sum, i) => sum + (Number(i.price) || 0),
                    0
                ),
            };

            const formDataToSend = new FormData();
            formDataToSend.append("packageData", new Blob([JSON.stringify(packageData)], { type: "application/json" }));

            if (formData.image instanceof File) {
                formDataToSend.append("image", formData.image);
            }

            const response = await fetch(
                `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/vendor/${vendorId}/package`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        // ❌ Do NOT add Content-Type here — let browser set it automatically
                    },
                    body: formDataToSend,
                }
            );

            const text = await response.text();
            console.log("🔹 Raw response:", text);

            if (!response.ok) {
                throw new Error(text);
            }

            alert("✅ Package saved successfully!");
            closeModal();
            fetchPackages();
        } catch (error) {
            console.error("❌ Error saving package:", error);
            alert(`❌ Failed to save package: ${error.message}`);
        }
    };



    // ---- DELETE PACKAGE ----
    // 🔹 Delete package function
    const handleDeletePackage = async (packageId) => {
        try {
            const vendorId = localStorage.getItem("vendorId");
            const token = localStorage.getItem("authToken");

            if (!vendorId || !token) {
                alert("⚠️ VendorId or Token missing in localStorage");
                return;
            }

            const confirmDelete = window.confirm("Are you sure you want to delete this package?");
            if (!confirmDelete) return;

            const url = `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/vendor/${vendorId}/${packageId}`;

            const response = await fetch(url, {
                method: "DELETE",
                headers: {
                    accept: "*/*",
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error("Failed to delete package");
            }

            alert("✅ Package deleted successfully!");
            // 🔹 Remove the deleted package from state
            setPackagesData((prev) => prev.filter((pkg) => pkg.id !== packageId));
        } catch (error) {
            console.error("❌ Error deleting package:", error);
            alert("Failed to delete package. Please try again.");
        }
    };


    return (


        <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }} className="catering-packge-page" >
            {/* Add Package Button */}
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-2">
                    </div>
                    <div className="col-lg-7">
                        <p
                            className="breadcrumb maamaas-home-bredcum"
                            style={{
                                position: "fixed",
                                top: isMobile ? "50px" : "80px",
                                left: isMobile ? "5px" : "18vw",
                                width: "100%",
                                backgroundColor: "#fff",
                                zIndex: 1000,
                                padding: "10px 0",
                                fontSize: isMobile ? "14px" : "18px",
                                fontWeight: isMobile ? "normal" : "bold",
                                textAlign: "center",
                                margin: 0,
                            }}
                        >
                            <Link
                                to="/Newmainlandingpage"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Home
                            </Link>

                            <span className="separator"> &gt; </span>
                            <Link
                                to="/cateringlading"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Catering & Services

                            </Link>

                            <span className="separator"> &gt; </span>
                            <Link

                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Menu_Management
                            </Link>
                        </p>
                        <div style={{ textAlign: "left", marginBottom: "20px" }}>
                            <button
                                onClick={() => openModal()}
                                style={{
                                    padding: "8px 12px",
                                    background: "linear-gradient(45deg, #9850b1ff, #ba66cfff)",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                    fontWeight: "bold",
                                    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                                }}
                            >
                                <FaPlus /> Add Package
                            </button>
                        </div>
                        <div style={{ height: "500px", overflow: "auto", scrollbarWidth: "none" }}>
                            {/* Display Packages */}
                            <div
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(auto-fit, minmax(264px, 1fr))",
                                    gap: "24px",
                                }}
                            >
                                {packagesData.map((pkg) => (
                                    <div
                                        key={pkg.id}
                                        style={{
                                            borderRadius: "12px",
                                            overflow: "hidden",
                                            background: "#fff",
                                            boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
                                            transition: "transform 0.2s ease",
                                        }}
                                    >
                                        {/* Image */}
                                        <div style={{ position: "relative" }}>
                                            <img
                                                src={pkg.imageUrl || "/default-image.jpg"} // <-- use blob URL
                                                alt={pkg.packageName}
                                                style={{ width: "100%", height: "180px", objectFit: "cover" }}
                                            />




                                            {/* Delete button top-right */}
                                            <button
                                                onClick={() => handleDeletePackage(pkg.id)}
                                                style={{
                                                    position: "absolute",
                                                    top: "10px",
                                                    right: "10px",
                                                    background: "#dc3545",
                                                    border: "none",
                                                    borderRadius: "50%",
                                                    padding: "8px",
                                                    cursor: "pointer",
                                                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                                                }}
                                            >
                                                <FaTrash color="white" />
                                            </button>

                                        </div>

                                        {/* Content */}
                                        <div style={{ padding: "15px" }}>
                                            <h3
                                                style={{
                                                    margin: "0 0 10px",
                                                    fontSize: "18px",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                {pkg.packageName} Package
                                            </h3>
                                            <span
                                                style={{
                                                    background:
                                                        mapPackageType(pkg.packageType) === "Veg"
                                                            ? "green"
                                                            : mapPackageType(pkg.packageType) === "Non_veg"
                                                                ? "red"
                                                                : "#007bff",
                                                    color: "white",
                                                    padding: "4px 12px",
                                                    borderRadius: "20px",
                                                    fontSize: "12px",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                {mapPackageType(pkg.packageType)}
                                            </span>

                                            <ul style={{ marginTop: "12px", paddingLeft: "20px", color: "#444" }}>
                                                {pkg.items.map((item) => (
                                                    <li key={item.id} style={{ marginBottom: "8px", position: "relative", paddingRight: "50px" }}>
                                                        {item.itemName} - ₹{item.price}

                                                        {/* Edit button */}
                                                        <button
                                                            onClick={() => openItemModal(pkg.id, item)}
                                                            style={{
                                                                position: "absolute",
                                                                top: "0",
                                                                right: "25px",
                                                                border: "none",
                                                                background: "transparent",
                                                                cursor: "pointer",
                                                            }}
                                                        >
                                                            <FaEdit color="#007bff" />
                                                        </button>

                                                        {/* Delete button */}
                                                        <button
                                                            onClick={() => handleDeleteItemss(pkg.id, item.id)}
                                                            style={{
                                                                position: "absolute",
                                                                top: "0",
                                                                right: "0",
                                                                border: "none",
                                                                borderRadius: "50%",
                                                                padding: "0px 5px",
                                                                cursor: "pointer",
                                                            }}
                                                        >
                                                            <FaTrash color="#dc3545" />
                                                        </button>
                                                    </li>
                                                ))}
                                            </ul>


                                        </div>

                                        {/* Footer */}
                                        <div
                                            style={{
                                                padding: "12px 15px",
                                                borderTop: "1px solid #eee",
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                background: "#fafafa",
                                            }}
                                        >
                                            <p style={{ margin: 0, fontWeight: "bold", color: "#333" }}>
                                                Total: ₹
                                                {pkg.totalPrice > 0
                                                    ? pkg.totalPrice
                                                    : pkg.items.reduce((sum, i) => sum + i.price, 0)}
                                            </p>
                                            <button
                                                onClick={() => handleEditPackage(pkg.id)}
                                                style={{
                                                    background: "#ffc107",
                                                    border: "none",
                                                    padding: "6px 12px",
                                                    borderRadius: "6px",
                                                    cursor: "pointer",
                                                    fontWeight: "bold",
                                                    color: "#fff",
                                                }}
                                            >
                                                <FaEdit />
                                            </button>

                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        {/* Modal */}
                        <Modal
                            isOpen={isModalOpen}
                            onRequestClose={closeModal}
                            contentLabel="Add/Edit Package"
                            style={{
                                content: {
                                    top: "55%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    maxWidth: "450px",
                                    width: "90%",
                                    borderRadius: "12px",
                                    padding: "25px",
                                    height: "470px",
                                    overflowY: "auto",
                                    boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
                                },
                            }}
                        >


                            <label>Package Name:</label>
                            <input
                                type="text"
                                value={formData.name}
                                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    marginBottom: "15px",
                                    borderRadius: "6px",
                                    border: "1px solid #ccc",
                                }}
                            />

                            <label>Package Type:</label>
                            <select
                                value={formData.type}
                                onChange={(e) => setFormData({ ...formData, type: e.target.value })}
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    marginBottom: "15px",
                                    borderRadius: "6px",
                                    border: "1px solid #ccc",
                                }}
                            >
                                <option value="Veg">Vegetarian</option>
                                <option value="Non_veg">Non-Vegetarian</option>
                                <option value="Drinks">Drinks</option>
                            </select>


                            <label>Upload Image:</label>
                            <input
                                type="file"
                                accept="image/*"
                                onChange={handleImageUpload}
                                style={{ marginBottom: "15px" }}
                            />

                            <label>Items:</label>
                            {formData.items.map((item, i) => (
                                <div key={i} style={{ display: "flex", marginBottom: "8px", gap: "5px" }}>
                                    <input
                                        type="text"
                                        placeholder="Item name"
                                        value={item.name}
                                        onChange={(e) => handleItemChange(i, "name", e.target.value)}
                                        style={{ flex: 2, padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
                                    />
                                    <input
                                        type="number"
                                        placeholder="Price"
                                        value={item.price}
                                        onChange={(e) => handleItemChange(i, "price", e.target.value)}
                                        style={{ flex: 1, padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
                                    />
                                    <button
                                        onClick={() => handleRemoveItem(i)}
                                        style={{
                                            background: "#dc3545",
                                            border: "none",
                                            color: "white",
                                            padding: "6px 10px",
                                            borderRadius: "4px",
                                            cursor: "pointer",
                                        }}
                                    >
                                        ✕
                                    </button>
                                </div>
                            ))}

                            <button
                                onClick={handleAddItem}
                                style={{
                                    background: "#17a2b8",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "5px",
                                    padding: "8px 14px",
                                    marginBottom: "15px",
                                    cursor: "pointer",
                                }}
                            >
                                + Add Item
                            </button>

                            <p style={{ fontWeight: "bold", marginBottom: "20px" }}>
                                Total Price: ₹{formData.items.reduce((sum, i) => sum + (Number(i.price) || 0), 0)}
                            </p>

                            <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
                                <button
                                    onClick={closeModal}
                                    style={{
                                        background: "#6c757d",
                                        color: "white",
                                        border: "none",
                                        borderRadius: "6px",
                                        padding: "10px 18px",
                                        cursor: "pointer",
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleSavePackage}
                                    style={{
                                        background: "#28a745",
                                        color: "white",
                                        border: "none",
                                        borderRadius: "6px",
                                        padding: "10px 18px",
                                        cursor: "pointer",
                                        fontWeight: "bold",
                                    }}
                                >
                                    {editingPackage ? "Save" : "Add"}
                                </button>
                            </div>
                        </Modal>
                        <Modal
                            isOpen={isItemModalOpen}
                            onRequestClose={closeItemModal}
                            contentLabel="Edit Item"
                            style={{
                                content: {
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    maxWidth: "400px",
                                    width: "90%",
                                    borderRadius: "12px",
                                    padding: "25px",
                                    height: "370px",
                                    overflowY: "auto",
                                    boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
                                },
                            }}
                        >
                            <h2 style={{ marginBottom: "15px", color: "#333" }}>Edit Item</h2>

                            <label>Item Name:</label>
                            <input
                                type="text"
                                value={editingItem?.itemName || ""}
                                onChange={(e) =>
                                    setEditingItem({ ...editingItem, itemName: e.target.value })
                                }
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    marginBottom: "15px",
                                    borderRadius: "6px",
                                    border: "1px solid #ccc",
                                }}
                            />

                            <label>Price (₹):</label>
                            <input
                                type="number"
                                value={editingItem?.price || ""}
                                onChange={(e) =>
                                    setEditingItem({ ...editingItem, price: e.target.value })
                                }
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    marginBottom: "15px",
                                    borderRadius: "6px",
                                    border: "1px solid #ccc",
                                }}
                            />

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginTop: "10px",
                                }}
                            >
                                <button
                                    onClick={closeItemModal}
                                    style={{
                                        background: "#6c757d",
                                        color: "white",
                                        border: "none",
                                        borderRadius: "6px",
                                        padding: "10px 18px",
                                        cursor: "pointer",
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleSaveItem}
                                    style={{
                                        background: "#28a745",
                                        color: "white",
                                        border: "none",
                                        borderRadius: "6px",
                                        padding: "10px 18px",
                                        cursor: "pointer",
                                        fontWeight: "bold",
                                    }}
                                >
                                    Save
                                </button>
                            </div>
                        </Modal>

                        <Modal
                            isOpen={isPackageModalOpen}
                            onRequestClose={closePackageModal}
                            contentLabel="Edit Package"
                            style={{
                                content: {
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    maxWidth: "450px",
                                    width: "90%",
                                    borderRadius: "12px",
                                    padding: "25px",
                                    maxHeight: "90vh",
                                    overflowY: "auto",
                                    boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
                                },
                            }}
                        >
                            {/* <h2>Edit Package</h2> */}

                            <label>Package Name:</label>
                            <input
                                type="text"
                                value={editingPackage.packageName}
                                onChange={(e) =>
                                    setEditingPackage({ ...editingPackage, packageName: e.target.value })
                                }
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    marginBottom: "15px",
                                    borderRadius: "6px",
                                    border: "1px solid #ccc",
                                }}
                            />

                            <label>Package Type:</label>
                            <select
                                value={editingPackage.packageType}
                                onChange={(e) =>
                                    setEditingPackage({ ...editingPackage, packageType: e.target.value })
                                }
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    marginBottom: "15px",
                                    borderRadius: "6px",
                                    border: "1px solid #ccc",
                                }}
                            >
                                <option value="Veg">Veg</option>
                                <option value="Non_veg">Non_veg</option>
                                <option value="Drinks">Drinks</option>
                            </select>

                            <label>Total Price:</label>
                            <input
                                type="number"
                                value={editingPackage.totalPrice}
                                onChange={(e) =>
                                    setEditingPackage({ ...editingPackage, totalPrice: Number(e.target.value) })
                                }
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    marginBottom: "15px",
                                    borderRadius: "6px",
                                    border: "1px solid #ccc",
                                }}
                            />

                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <button onClick={closePackageModal} style={{
                                    background: "#6c757d",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "6px",
                                    padding: "10px 18px",
                                    cursor: "pointer",
                                }}>
                                    Cancel
                                </button>
                                <button onClick={handleSavePackagess} style={{
                                    background: "#28a745",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "6px",
                                    padding: "10px 18px",
                                    cursor: "pointer",
                                    fontWeight: "bold",
                                }}>
                                    Save
                                </button>
                            </div>
                        </Modal>

                        <Modal
                            isOpen={isEditModalOpen}
                            onRequestClose={closeModal}
                            style={{
                                content: {
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    maxWidth: "450px",
                                    width: "90%",
                                    borderRadius: "12px",
                                    padding: "25px",
                                    maxHeight: "90vh",
                                    overflowY: "auto",
                                    boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
                                },
                            }}
                        >
                            <h2>Edit Package</h2>

                            <div>
                                <label>Package Name</label>
                                <input
                                    type="text"
                                    value={formData.packageName}
                                    onChange={(e) => setFormData({ ...formData, packageName: e.target.value })}
                                    style={{
                                        width: "100%",
                                        padding: "10px",
                                        marginBottom: "15px",
                                        borderRadius: "6px",
                                        border: "1px solid #ccc",
                                    }}
                                />
                            </div>

                            <div>
                                <label>Package Type</label>
                                <select
                                    value={formData.packageType}
                                    onChange={(e) =>
                                        setFormData({ ...formData, packageType: e.target.value })
                                    }
                                    style={{
                                        width: "100%",
                                        padding: "10px",
                                        marginBottom: "15px",
                                        borderRadius: "6px",
                                        border: "1px solid #ccc",
                                    }}
                                >
                                    <option value="Veg">Veg</option>
                                    <option value="Non_veg">Non_Veg</option>
                                    <option value="Drinks">Drinks</option>
                                </select>
                            </div>


                            <div>
                                <label>Package Image</label>
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => setFormData({ ...formData, imageFile: e.target.files[0] })}
                                    style={{
                                        width: "100%",
                                        padding: "10px",
                                        marginBottom: "15px",
                                        borderRadius: "6px",
                                        border: "1px solid #ccc",
                                    }}
                                />
                            </div>

                            <button
                                onClick={handleUpdatePackage}
                                style={{
                                    backgroundColor: "#b15cd6",
                                    color: "#fff",
                                    padding: "10px 20px",
                                    borderRadius: "8px",
                                    border: "none",
                                    cursor: "pointer",
                                }}
                            >
                                Save Changes
                            </button>
                        </Modal>

                    </div>
                    <div className="col-lg-3">
                        <Cateringascrolling />
                    </div>
                </div>
            </div>

        </div>
    );
}


